export const LOCAL_EVENT_OPEN_BACKGROUND_DIALOG =
  "local-event/open-background-dialog";
export const LOCAL_EVENT_OPEN_SETTINGS_DIALOG =
  "local-event/open-settings-dialog";
export const LOCAL_EVENT_OPEN_FITWICK_LIST = "local-event/open-fitwick-list";
export const LOCAL_EVENT_OPEN_ADD_FITWICK_DIALOG =
  "local-event/open-add-fitwick-dialog";
